import React from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import AppLayout from "layouts/app-layout";
import AuthLayout from 'layouts/auth-layout';
import AppLocale from "lang";
import { IntlProvider } from "react-intl";
import { ConfigProvider } from 'antd';
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH, PAYMENT_PREFIX_PATH } from 'configs/AppConfig';
import { authenticated } from 'redux/actions/Auth';
import axiosInterceptor from '../auth/AxiosInterceptor';
import PaymentLayout from "layouts/payment-layout";

function RouteInterceptor({ children, isAuthenticated, currentLocation, ...rest }) {

  const paymentData = JSON.parse(localStorage.getItem("PAYMENT_DATA"));
  const appUserRoleId = localStorage.getItem("USER_ROLE_ID");
  let loginRenderModes = []

  if (paymentData) {
    loginRenderModes = [
      !paymentData.isEnablePaymentMode ? 'systemLog' : undefined,
      paymentData.isEnablePaymentMode && !paymentData.isPaymentSetup ? 'paymentPath' : undefined,
      paymentData.isEnablePaymentMode && paymentData.isPaymentSetup && paymentData.isTrialActive && paymentData.isTrialCompleted ? 'paymentPath': undefined
    ]
  }

	const loginRenderMode =
		loginRenderModes.find(Boolean) ?? 'systemLog'

	const loginMode = () => {
    localStorage.setItem("LOGIN_RENDER_MODE", loginRenderMode);
		if (loginRenderMode === 'systemLog') {
			return children
		}

		if (loginRenderMode === 'paymentPath') {
			return appUserRoleId == "11111111-1111-1111-1111-111111111111"?<Redirect
				to="/payment/subcription-plan"
			/>:<Redirect
      to="/payment/error"
    />
		}
	}
  
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated && currentLocation ? 
        (
          loginMode()
        ) : (
          <Redirect
            to={{
              pathname: AUTH_PREFIX_PATH,
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}

export const Views = (props) => {
  const { locale, location, token, authenticated, currentLocation } = props;
  const currentAppLocale = AppLocale[locale];
  const searchParams = new URLSearchParams(location.search);
  const urlToken = searchParams.get('token');
  const urlAppUserId = searchParams.get('app-user-id');
  const urlLocationId = searchParams.get('location-id');
  let authToken = token;
  if (urlToken && urlAppUserId && urlLocationId) {
    authToken = urlToken;
    authenticated(urlToken);
    localStorage.setItem('AUTH_TOKEN' , urlToken);
    localStorage.setItem('APP_USER_ID' , urlAppUserId);
    localStorage.setItem('LOCATION_ID' , urlLocationId);
  }
  axiosInterceptor();

  return (
    <IntlProvider
      locale={currentAppLocale.locale}
      messages={currentAppLocale.messages}>
      <ConfigProvider locale={currentAppLocale.antd}>
        <Switch>
          <Route exact path="/">
            <Redirect to={APP_PREFIX_PATH} />
          </Route>
          <Route path={AUTH_PREFIX_PATH}>
            <AuthLayout />
          </Route>
          <Route path={PAYMENT_PREFIX_PATH} isAuthenticated={authToken} currentLocation={currentLocation}>
            <PaymentLayout location={location}/>
          </Route>
          <RouteInterceptor path={APP_PREFIX_PATH} isAuthenticated={authToken} currentLocation={currentLocation}>
            <AppLayout location={location}/>
          </RouteInterceptor>
        </Switch>
      </ConfigProvider>
    </IntlProvider>
  )
}

const mapStateToProps = ({ theme, auth, main }) => {
  const { locale } =  theme;
  const { token } = auth;
  const currentLocation = main.location;
  return { locale, token, currentLocation }
};

const mapDispatchToProps = {
	authenticated
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Views));